import { render, staticRenderFns } from "./gender-chart.vue?vue&type=template&id=1628f5a3&"
import script from "./gender-chart.vue?vue&type=script&lang=js&"
export * from "./gender-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports